import { render, staticRenderFns } from "./AuditoriaCuentaCobro.vue?vue&type=template&id=6063d442&scoped=true"
import script from "./AuditoriaCuentaCobro.vue?vue&type=script&lang=js"
export * from "./AuditoriaCuentaCobro.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaCuentaCobro.vue?vue&type=style&index=0&id=6063d442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063d442",
  null
  
)

export default component.exports